'use client';

import { animated, Transition } from '@react-spring/web';
import { useState } from 'react';
import { useInterval } from 'react-use';

import { easeInOutExpo } from '@/lib/util/easeInOutExpo';

import styles from './Slider.module.scss';

const SLIDE_CHANGE_INTERVAL_MS = 3000;
const SLIDE_TRANSITION_DURATION_MS = 500;

interface Props {
    countries: string[];
}

export function Slider({ countries }: Props) {
    const [activeSlideIndex, setActiveSlideIndex] = useState(0);

    useInterval(() => {
        const nextState = (i: number) => (i + 1) % countries.length;
        setActiveSlideIndex(nextState);
    }, SLIDE_CHANGE_INTERVAL_MS);

    return (
        <div>
            <span>Made with love from </span>
            <span className={styles.slideWrapper}>
                <Transition
                    items={activeSlideIndex}
                    initial={{ opacity: 1, transform: 'translate3d(0, 0%, 0)' }}
                    from={{
                        opacity: 0,
                        transform: `translate3d(0, 50% ,0)`,
                    }}
                    enter={{ opacity: 1, transform: 'translate3d(0, 0%, 0)' }}
                    leave={{
                        opacity: 0,
                        transform: 'translate3d(0, -50%, 0)',
                    }}
                    config={{
                        duration: SLIDE_TRANSITION_DURATION_MS,
                        easing: easeInOutExpo,
                    }}
                >
                    {(style, index) => (
                        <animated.span className={styles.slide} style={style}>
                            {countries[index]}.
                        </animated.span>
                    )}
                </Transition>
            </span>
        </div>
    );
}
